import { IonContent, IonPage } from '@ionic/react';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { JobMessages } from '../../intl/JobMessages';
import DesktopHeader from 'src/components/reusable-components/desktop-header/DesktopHeader';
import { useHistory, useLocation } from 'react-router';
import React from 'react';
import { MobileLogListPageActions } from './MobileLogsListPage';
import { JobSyncSlide } from 'src/components/job-sync-slide/JobSyncSlide';
import LogsTable from '../../components/jobs-list/LogsTable';
import { useToast } from 'src/components/reusable-components/useToast';
import { englishOnlyIntl, useGA4 } from '../../utils/ga4';

const LogsListPage: FC = () => {
  document.title = englishOnlyIntl.formatMessage(JobMessages.jobLogsTitle);
  useGA4();

  const intl = useIntl();
  const history = useHistory();
  const [present] = useToast();
  const { state: locationState } = useLocation<{ action?: MobileLogListPageActions }>();

  React.useEffect(() => {
    if (!!locationState?.action && locationState.action === MobileLogListPageActions.DeleteSuccessful) {
      history.replace({ state: {} });

      present(
        {
          message: intl.formatMessage(JobMessages.successfulJobDeletionMessage),
        },
        'success',
      );
    }
  }, [history, intl, locationState, present]);

  return (
    <IonPage>
      <DesktopHeader title={intl.formatMessage(JobMessages.jobLogsTitle)} />
      <IonContent>
        <JobSyncSlide className="ion-margin-bottom" />
        <LogsTable />
      </IonContent>
    </IonPage>
  );
};

export default LogsListPage;
